import http from './http'

export async function getMyInfo() {
  try {
    const res = await http.get('/user/info/my')
    return res.data
  } catch (error) {
    console.warn('获取用户信息失败，使用模拟数据作为兜底', error)
    // 返回模拟的管理员数据，确保页面能正常加载
    return {
      code: 1,
      data: {
        id: 'mock-admin-id',
        username: 'admin',
        name: '系统管理员(Mock)',
        roleCode: 'admin',
        department: '模拟教研室'
      }
    }
  }
}

export async function updateMyInfo(payload) {
  const res = await http.put('/user/info/my', payload)
  return res.data
}

export async function submitFeedback(payload) {
  const res = await http.post('/feedback', payload)
  return res.data
}
